/**
 * Mirrors the backend enum. The seven SALES types a user is offered (E4 RF-01) are listed in
 * `SALES_ACTIVITY_TYPES` (`kanban/kanban.types.ts`); every earlier value stays valid and readable
 * on the activities that carry it (RF-02).
 */
export enum TaskTypeEnum {
  PRESENTATION = 'PRESENTATION',
  APPOINTMENT = 'APPOINTMENT',
  FEEDBACK_COLLECTION = 'FEEDBACK_COLLECTION',
  FOLLOW_UP = 'FOLLOW_UP',
  CALL = 'CALL',
  NOTE = 'NOTE',
  MEETING = 'MEETING',
  TASK = 'TASK',
  TRAINING = 'TRAINING',
  VISIT = 'VISIT',
  OTHERS = 'OTHERS',
  WHATSAPP = 'WHATSAPP',
  EMAIL = 'EMAIL',
}
